import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import classNames from 'classnames';

import bgImage from '../../images/lead-bg.webp';
import './order-steps-section.css';

const stepsLabels = [
  'Choose your bike',
  'Enter your details',
  'Pay and receive confirmation'
];

const OrderStepsSection = ({
  t,
  activeStep,
  orderParamsString,
  title
}) => (
  <div className="order-steps-section">
    <div className="order-steps-section__bg">
      <img
        alt="Amsterdam сyclist"
        width={1400}
        height={728}
        src={bgImage}
      />
    </div>

    <Grid className="order-steps-section__container">
      {(activeStep === 1) && (
        <div>
          <h1>{title}</h1>

          <h4 className="order-params-string">
            {orderParamsString}
          </h4>
        </div>
      )}

      <ul className="order-steps-list">
        {[...Array(3).keys()].map((step) => (
          <Fragment key={step + 1}>
            <li
              className={classNames('order-step', `order-step-${step + 1}`, {
                'order-step-active': step + 1 === activeStep
              })}
            >
              <span>{t(stepsLabels[step])}</span>
            </li>
            {' '}
          </Fragment>
        ))}
      </ul>
    </Grid>
  </div>
);

OrderStepsSection.propTypes = {
  t: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  searchParamsString: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default translate(['translation'])(OrderStepsSection);



// WEBPACK FOOTER //
// ./src/widgets/OrderStepsSection/index.js